/**
 * @ngdoc controllers
 * @memberof mercury.modules.reports
 * @name ReportsStaffTablesCtrl
 */
angular.module('mercury.modules.reports.staff')
.controller('ReportsStaffTablesCtrl', ["$scope", "ReportPosStaff", "reporttime", "$stateParams", "$filter", "title", function($scope, ReportPosStaff, reporttime, $stateParams, $filter, title) {
  $scope.staffTablesCols = [
    {label: 'Staff Name', type: 'string', key: 'staffName'},
    {label: 'Tables Opened', type: 'number', key: 'count'}
  ];

  title.set('Tables By Staff');
  $scope.loading = ReportPosStaff.getTables(reporttime.start(), reporttime.end());

  $scope.loading.then(function(results) {
    var totalCount = 0;
    var totalHeads = 0;
    var totalInvoices = 0;

    angular.forEach(results, function(staffMember) {
      staffMember.averageHeads = (staffMember.count !== 0) ? staffMember.heads / staffMember.count : 0;
      staffMember.averageInvoicesPerHead = (staffMember.heads !== 0) ? staffMember.invoices / staffMember.heads : 0;
      totalCount += staffMember.count;
      totalHeads += staffMember.heads;
      totalInvoices += staffMember.invoices;
    });

    results.sort(function(a, b) { return (a.count < b.count) ? 1 : -1;});
    $scope.staffMembers = results;
    $scope.totalCount = totalCount;
    $scope.totalHeads = totalHeads;
    $scope.totalInvoices = totalInvoices;
    $scope.averageHeads = (totalCount !== 0) ? totalHeads / totalCount : 0;
    $scope.averageInvoicesPerHead = (totalHeads !== 0) ? totalInvoices / totalHeads : 0;
  });
}]);
